var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "itemsRow" }, [
    _vm.item.section
      ? _c("div", { staticClass: "isection d-flex" }, [
          _vm.item.sectionContent.indexOf("data-prefix") !== -1
            ? _c(
                "div",
                { staticClass: "prefix" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myAccent mr-1", attrs: { large: "" } },
                    [_vm._v("mdi-star")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("div", {
            staticClass: "fontColor",
            domProps: { innerHTML: _vm._s(_vm.item.sectionContent) },
          }),
        ])
      : _c("div", [
          _c("h3", { staticClass: "itemTitle headColor" }, [
            _vm._v(_vm._s(_vm.item.nameDE)),
          ]),
          _c("div", { staticClass: "fontColor textFont" }, [
            _vm._v(_vm._s(_vm.item.descriptionDE)),
          ]),
          _vm.item.sizes
            ? _c(
                "div",
                {
                  staticClass: "pt-1 d-flex",
                  staticStyle: { "justify-content": "flex-end" },
                },
                [
                  _vm.fordrinks
                    ? [
                        _c(
                          "div",
                          [
                            _vm.hasReplaceArticle
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "fontColor maxw text-right",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm._f("basePrice")(_vm.item))
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._l(_vm.item.sizes, function (size) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "d-flex",
                                      staticStyle: { "line-height": "1.5em" },
                                    },
                                    [
                                      size.vol
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "fontColor itemSubtitle mr-2 text-no-wrap",
                                            },
                                            [_vm._v(_vm._s(size.vol))]
                                          )
                                        : _vm._e(),
                                      !_vm.$store.getters.hidePrices
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "fontColor maxw text-right",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("price")(
                                                    size.price,
                                                    true
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                          ],
                          2
                        ),
                      ]
                    : [
                        !_vm.$store.getters.hidePrices
                          ? _c("div", [
                              _vm.hasReplaceArticle
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "fontColor maxw text-right",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("basePrice")(_vm.item)
                                            )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c("div", { staticClass: "fontColor" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("price")(
                                            _vm.item.sizes[0].price,
                                            true
                                          )
                                        )
                                    ),
                                  ]),
                            ])
                          : _vm._e(),
                      ],
                  _c("v-icon", { staticClass: "myAccent" }, [
                    _vm._v("mdi-chevron-right"),
                  ]),
                ],
                2
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }